import { LazyResolver } from '../resolvers/LazyResolver';
import { decorateParameterOrProperty } from './decorateParameterOrProperty';
/**
 * Decorator: Specifies the dependency should be lazy loaded.
 *
 * @export
 */
export function Lazy(keyValue) {
    const resolver = LazyResolver.of(keyValue);
    return decorateParameterOrProperty(x => resolver, 'lazy');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGF6eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxhenkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLDJCQUEyQixDQUFDO0FBRXpELE9BQU8sRUFBRSwyQkFBMkIsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBRTVFOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsSUFBSSxDQUFDLFFBQWtCO0lBQ25DLE1BQU0sUUFBUSxHQUFHLFlBQVksQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLENBQUM7SUFFM0MsT0FBTywyQkFBMkIsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLFFBQVEsRUFBRSxNQUFNLENBQUMsQ0FBQztBQUM5RCxDQUFDIn0=